import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import CampaignCartIndex from '../pages/CampaignCartIndex.vue';

import Currency from '../components/Currency.vue';

class CampaignCartIndexComponent {
  constructor({ container, props = {} }) {
    this.app = null;
    this.container = container;
    this.props = props;
  }

  init() {
    this.app = createApp(CampaignCartIndex, this.props);
    this.app.use(I18NextVue, { i18next });
    this.app.use(VueLazyload, {
      preLoad: 2.6 // default 1.3
    });

    this.app.component('Currency', Currency);

    // Mount the Vue app to the specified container
    this.app.mount(this.container);
  }

  destroy() {
    if (this.app) {
      this.app.unmount();
      this.app = null;
    }
  }
}

export default CampaignCartIndexComponent;
